import Vue from 'vue'
import Router from 'vue-router'
import Main from '../views/Main.vue'

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: '登录',
            meta: {login: false, share: false},
            component: () => import('../views/login/Login.vue')
        },
        {
            path: '/auth',
            name: '授权中',
            meta: {login: false, share: false},
            component: () => import('../views/login/Auth.vue')
        },
        {
            path: '/register',
            name: '注册',
            meta: {login: false, share: false},
            component: () => import('../views/login/Register.vue')
        },
        {
            path: '/forgotPassword',
            name: '忘记密码',
            meta: {login: false, share: false},
            component: () => import('../views/login/ForgotPassword.vue')
        },
        {
            path: '/',
            name: '益宝',
            component: Main,
            redirect: '/home',
            children: [
                {
                    path: '/home',
                    name: '首页',
                    meta: {login: false, share: true},
                    component: () => import('../views/home/Home.vue')
                },
                {
                    path: '/me',
                    name: '我的',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/Me.vue')
                },
                {
                    path: '/discover',
                    name: '金融教育',
                    meta: {login: false, share: false},
                    component: () => import('../views/discover/Discover.vue')
                },
                {
                    path: '/about',
                    name: '关于我们',
                    meta: {login: true, share: false},
                    // route level code-splitting
                    // this generates a separate chunk (about.[hash].js) for this route
                    // which is lazy-loaded when the route is visited.
                    component: () => import(/* webpackChunkName: "about" */ '../views/me/modules/About.vue')
                },
                {
                    path: '/productList',
                    name: '产品列表',
                    meta: {login: false, share: true},
                    component: () => import('../views/home/modules/ProductList.vue')
                },
                {
                    path: '/productDetail',
                    name: '产品详情',
                    meta: {login: false, share: false},
                    component: () => import('../views/home/modules/ProductDetail.vue')
                },
                {
                    path: '/custProductDetail',
                    name: '产品简介',
                    meta: {login: false, share: false},
                    component: () => import('../views/home/modules/CustProductDetail.vue')
                },
                {
                    path: '/articleDetail',
                    name: '文章',
                    meta: {login: false, share: true},
                    component: () => import('../views/home/modules/ArticleDetail.vue')
                },
                {
                    path: '/ambassadorList',
                    name: '枢纽伙伴列表',
                    meta: {login: false, share: false},
                    component: () => import('../views/home/modules/AmbassadorList.vue')
                },
                {
                    path: '/ambassadorDetail',
                    name: '枢纽伙伴详情',
                    meta: {login: false, share: true},
                    component: () => import('../views/home/modules/AmbassadorDetail.vue')
                },
                {
                    path: '/profile',
                    name: '个人信息',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Profile.vue')
                },
                {
                    path: '/editProfile',
                    name: '编辑个人信息',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/EditProfile.vue')
                },
                {
                    path: '/collection',
                    name: '我的收藏',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Collection.vue')
                },
                {
                    path: '/familyList',
                    name: '我的家人',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/FamilyList.vue')
                },
                {
                    path: '/myClient',
                    name: '我的客户',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/MyClient.vue')
                },
                {
                    path: '/clientDetail',
                    name: '客户详情',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/ClientDetail.vue')
                },
                {
                    path: '/addFamily',
                    name: '添加家人',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/AddFamily.vue')
                },
                {
                    path: '/familyDetail',
                    name: '家人详情',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/FamilyDetail.vue')
                },
                {
                    path: '/applyAmbassador',
                    name: '申请',
                    meta: {login: true, share: false},
                    component: () => import('../views/home/modules/ApplyAmbassador.vue')
                },
                {
                    path: '/orderList',
                    name: '保单',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/OrderList.vue')
                },
                {
                    path: '/myOrder',
                    name: '我的投保',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/MyOrder.vue')
                },
                {
                    path: '/orderDetail',
                    name: '保单详情',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/OrderDetail.vue')
                },
                {
                    path: '/familyOrder',
                    name: '家庭保单',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/FamilyOrder.vue')
                },
                {
                    path: '/share',
                    name: '推广达人',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Share.vue')
                },
                {
                    path: '/rank',
                    name: '排行榜',
                    meta: {login: true, share: true},
                    component: () => import('../views/me/modules/Rank.vue')
                },
                {
                    path: '/invited',
                    name: '已邀请',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Invited.vue')
                },
                {
                    path: '/invitationCard',
                    name: '邀请卡',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/InvitationCard.vue')
                },
                {
                    path: '/generateInvitation',
                    name: '生成邀请卡',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/GenerateInvitation.vue')
                },
                {
                    path: '/integral',
                    name: '积分',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Integral.vue')
                },
                {
                    path: '/integralDetail',
                    name: '积分明细',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/IntegralDetail.vue')
                },
                {
                    path: '/messages',
                    name: '消息',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Messages.vue')
                },
                {
                    path: '/messageDetail',
                    name: '消息详情',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/MessageDetail.vue')
                },
                {
                    path: '/claim',
                    name: '理赔',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Claim.vue')
                },
                {
                    path: '/applyClaim',
                    name: '发起理赔',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/ApplyClaim.vue')
                },
                {
                    path: '/claimQuery',
                    name: '理赔查询',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/ClaimQuery.vue')
                },
                {
                    path: '/claimProgress',
                    name: '理赔进度',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/ClaimProgress.vue')
                },
                {
                    path: '/study',
                    name: '学习资料',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Study.vue')
                },
                {
                    path: '/protectionScheme',
                    name: '保障定制',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/ProtectionScheme.vue')
                },
                {
                    path: '/help',
                    name: '联系客服',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/Help.vue')
                },
                {
                    path: '/buy',
                    name: '购买',
                    meta: {login: true, share: false},
                    component: () => import('../views/home/modules/Buy.vue')
                },
                {
                    path: '/order',
                    name: '订单信息',
                    meta: {login: true, share: false},
                    component: () => import('../views/home/modules/Order.vue')
                },
                {
                    path: '/myCheck',
                    name: '我的体检',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/MyCheck.vue')
                },
                {
                    path: '/checkDetail',
                    name: '体检详情',
                    meta: {login: true, share: false},
                    component: () => import('../views/me/modules/CheckDetail.vue')
                },
                {
                    path: '/sharePoster',
                    name: '分享海报',
                    meta: {login: true, share: false},
                    component: () => import('../views/home/modules/SharePoster.vue')
                },
            ]
        },
        {
            path: '/Ahome',
            name: '视安保',
            component: () => import('../views/anshibao/Ahome.vue')
        },
        {
            path: '/AInsurancePolicy',
            name: '视安保',
            meta: {login: true, share: false},
            component: () => import('../views/anshibao/AInsurancePolicy.vue')
        },
        {
            path: '/ApolicyDetails',
            name: '保单详情',
            meta: {login: true, share: false},
            component: () => import('../views/anshibao/ApolicyDetails.vue')
        },
        {
            path: '/Aproblem',
            name: '常见问题',
            component: () => import('../views/anshibao/Aproblem.vue')
        },
        {
            path: '/AclaimsProcess',
            name: '理赔流程',
            component: () => import('../views/anshibao/AclaimsProcess.vue')
        },
        {
            path: '/Aproduce',
            name: '产品展示',
            component: () => import('../views/anshibao/Aproduce.vue')
        },
        {
            path: '/Aproblemdetail',
            name: '问题详情',
            component: () => import('../views/anshibao/Aproblemdetail.vue')
        },
    ]
})
